import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, Button, CircularProgress, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';

export default function UpgradeSuccessPage() {
  const { isPremium, isAdmin, refreshUserDoc } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [attempts, setAttempts] = useState(0);

  // Poll Firestore for plan upgrade — webhook may take a few seconds
  useEffect(() => {
    if (isPremium || isAdmin) { setChecking(false); return; }
    if (attempts >= 10) { setChecking(false); return; }

    const timer = setTimeout(async () => {
      await refreshUserDoc?.();
      setAttempts(a => a + 1);
    }, 1500);
    return () => clearTimeout(timer);
  }, [isPremium, isAdmin, attempts, refreshUserDoc]);

  const confirmed = isPremium || isAdmin;

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Navbar />
      <Container maxWidth="sm" sx={{ py: 10, textAlign: 'center' }}>
        {checking && !confirmed ? (
          <>
            <CircularProgress color="success" size={56} sx={{ mb: 3 }} />
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>Activating Nerds+…</Typography>
            <Typography sx={{ color: '#9eb8d0' }}>Verifying your payment — just a moment.</Typography>
          </>
        ) : confirmed ? (
          <>
            <Typography sx={{ fontSize: '4rem', mb: 2 }}>🎉</Typography>
            <Typography variant="h3" sx={{ fontWeight: 900, mb: 1 }}>Welcome to Nerds+</Typography>
            <Chip label="⚡ PREMIUM ACTIVE" color="success" sx={{ fontWeight: 800, mb: 3, fontSize: '0.8rem' }} />
            <Typography sx={{ color: '#9eb8d0', mb: 4, fontSize: '1.05rem' }}>
              You now have full access to all premium analytics — Drive EPA Explorer, QB Situational Splits,
              Red Zone Tendencies, player-level EPA, and everything we ship next.
            </Typography>
            <Button variant="contained" color="primary" size="large" onClick={() => navigate('/nerd-stats')}
              sx={{ textTransform: 'none', fontWeight: 700, px: 4, py: 1.25, fontSize: '1rem', mr: 2 }}>
              Explore Premium Analytics →
            </Button>
            <Button variant="outlined" color="secondary" onClick={() => navigate('/')}
              sx={{ textTransform: 'none' }}>
              Home
            </Button>
          </>
        ) : (
          <>
            <Typography sx={{ fontSize: '3rem', mb: 2 }}>✅</Typography>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 2 }}>Payment Received</Typography>
            <Typography sx={{ color: '#9eb8d0', mb: 2 }}>
              Your Nerds+ subscription is confirmed. Your account will upgrade within a few minutes.
              If you don't see premium access after 5 minutes, reach out via the contact page.
            </Typography>
            <Typography variant="caption" sx={{ color: '#4a6080', display: 'block', mb: 4 }}>
              You'll receive a confirmation email from Stripe.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/')}
              sx={{ textTransform: 'none', fontWeight: 700 }}>
              Go to Homepage
            </Button>
          </>
        )}
      </Container>
    </Box>
  );
}
